import { render } from "./VacancyInner.vue?vue&type=template&id=5e26024f&scoped=true"
import script from "./VacancyInner.vue?vue&type=script&lang=js"
export * from "./VacancyInner.vue?vue&type=script&lang=js"

import "./VacancyInner.vue?vue&type=style&index=0&id=5e26024f&scoped=true&lang=css"

import exportComponent from "/Users/ratitsiklauri/DevProjects/DK-Projects/recturing-front-vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e26024f"]])

export default __exports__